(function() {
  'use strict';
  
  const VideoModal = {
    modal: null,
    video: null,
    overlay: null,
    closeBtn: null,
    
    init: function() {
      this.modal = document.getElementById('video-modal');
      this.video = document.getElementById('video-player');
      this.overlay = this.modal.querySelector('.video-modal__overlay');
      this.closeBtn = this.modal.querySelector('.video-modal__close');
      
      this.bindEvents();
      this.interceptVideoLinks();
      this.checkHashOnLoad();
    },
    
    bindEvents: function() {
      const self = this;
      
      this.closeBtn.addEventListener('click', function() {
        self.close();
      });
      
      this.overlay.addEventListener('click', function() {
        self.close();
      });
      
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.modal.classList.contains('is-active')) {
          self.close();
        }
      });
      
      this.modal.addEventListener('transitionend', function() {
        if (self.modal.classList.contains('is-active')) {
          document.body.style.overflow = 'hidden';
        }
      });
      
      window.addEventListener('hashchange', function() {
        self.handleHashChange();
      });
    },
    
    interceptVideoLinks: function() {
      const self = this;
      
      document.addEventListener('click', function(e) {
        const link = e.target.closest('a[href*="#open-video="]');
        
        if (link) {
          e.preventDefault();
          const hash = link.getAttribute('href');
          const videoUrl = hash.replace('#open-video=', '');
          
          if (videoUrl) {
            window.location.hash = hash;
          }
        }
      });
    },
    
    checkHashOnLoad: function() {
      this.handleHashChange();
    },
    
    handleHashChange: function() {
      const hash = window.location.hash;
      
      if (hash.startsWith('#open-video=')) {
        const videoUrl = hash.replace('#open-video=', '');
        this.open(videoUrl);
      } else if (this.modal.classList.contains('is-active')) {
        this.close();
      }
    },
    
    open: function(videoUrl) {
      this.video.src = decodeURIComponent(videoUrl);
      this.modal.style.display = 'block';
      this.modal.offsetHeight;
      this.modal.classList.add('is-active');
      
      this.video.play().catch(function(error) {
        console.log('Autoplay blocked:', error);
      });
    },
    
    close: function() {
      const self = this;
      
      this.video.pause();
      this.video.currentTime = 0;
      this.modal.classList.remove('is-active');
      
      setTimeout(function() {
        self.modal.style.display = 'none';
        self.video.src = '';
        document.body.style.overflow = '';
      }, 300);
      
      if (window.location.hash.startsWith('#open-video=')) {
        history.pushState('', document.title, window.location.pathname + window.location.search);
      }
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      VideoModal.init();
    });
  } else {
    VideoModal.init();
  }
})();